module.exports = __webpack_public_path__ + "static/media/Nsingani.abbfa56c.jpg";